import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate,useParams } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import BusinessService from "./Businesses.service";
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import SectionFilter from "../../components/Table Filters/AppAddressesFilter";
import PermissionAccess from '../../PermissionAccess/Access.js';


const TabSection = ({patient_id}) => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterDocument1, setFilterDocument1] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchSections(0, pageLimit);
  }, [pageLimit]);

  function fetchSections(page_index, page_limit,document1) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    DiscountCouponService.GetAppAddresses(authData.sessionID,offset, page_limit,patient_id,document1).then(
      (response) => {
        setLoading(false);
        console.log("Get sections response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          console.log(response.data);
          setSections(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }

  const mycolumns = [

    {
        name: t('Title'),
        selector: "name",
        width: "15%",
        sortable: true,
    },


    {
        name: t('Unit No'),
        selector: "unit_no",
        width: "15%",
        sortable: true,
    },

    {
    name: t('Postal Code'),
    selector: "postal_code",
    width: "15%",
    sortable: true,
    },

    {
    name: t('address'),
    selector: "address",
    width: "55%",
    sortable: true,
    },

  ];


  const handleSearch = (document1) => {
    setFilterDocument1(document1);
    if (document1 !== '') {
      fetchSections(0, pageLimit,document1)
    }
  };

  const handleClear = () => {
    setFilterDocument1('');
    fetchSections(0, pageLimit);
  };
  const filteredItems = sections;

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <SectionFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterDocument1={filterDocument1}
      />
    );
  }, [filterDocument1]);


  function handlePageChange(page_index) {
    console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchSections(page_index, pageLimit,filterDocument1);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  return (
    <Fragment>
      <Col md="12" className="mx-auto app-login-box">

        <Row>
          <LoadingOverlay
            tag="div"
            active={loading}
            styles={{ overlay: (base) => ({ ...base }) }}
            spinner={<DNALoader />}
          >
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                    {subHeaderComponentMemo}
                  </Col>
                  <DataTable
                    data={filteredItems}
                    columns={mycolumns}
                    pagination
                    fixedHeader
                    fixedHeaderScrollHeight="400px"
                    subHeader
                    subHeaderComponent={
                      <div>
                        
                       
                      </div>
                    }

                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationResetDefaultPage={resetPaginationToggle}

                  />
                </CardBody>
              </Card>
            </Col>
          </LoadingOverlay>
        </Row>
      </Col>
    </Fragment>
  );
};

export default TabSection;
